// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__3P7yT","select":"Header_select__23BoY","clinic":"Header_clinic__2oOzL"};